// Derives the MediaSource Extensions `video/mp4; codecs="..."` string that
// matches an instance's actual ffmpeg output (its resolved videoCodec/
// audioCodec, see ActiveInstance in @expostreamer/shared-types).
//
// The exact profile/level suffix on an encoder can't be derived from the
// codec name alone (it depends on the source material), so each family
// maps to one representative, broadly-compatible string.
//
// Kept local to react/ rather than in the shared-types package: it's the
// only runtime (non-type) use of that package, and react-scripts only runs
// Babel over files inside src/, so a real value import from the workspace
// package's TS source wouldn't bundle.

const VIDEO_CODEC_MAP: Record<string, string> = {
  h264: 'avc1.640028',
  libx264: 'avc1.640028',
  h264_videotoolbox: 'avc1.640028',
  h264_nvenc: 'avc1.640028',
  h264_qsv: 'avc1.640028',
  h264_v4l2m2m: 'avc1.640028',
  hevc: 'hvc1.1.6.L120.90',
  libx265: 'hvc1.1.6.L120.90',
  hevc_videotoolbox: 'hvc1.1.6.L120.90',
  hevc_nvenc: 'hvc1.1.6.L120.90',
  hevc_qsv: 'hvc1.1.6.L120.90',
  av1: 'av01.0.05M.08',
  libaom_av1: 'av01.0.05M.08',
  'libaom-av1': 'av01.0.05M.08',
  av1_nvenc: 'av01.0.05M.08',
  vp9: 'vp09.00.10.08',
  libvpx_vp9: 'vp09.00.10.08',
  'libvpx-vp9': 'vp09.00.10.08',
}

const AUDIO_CODEC_MAP: Record<string, string> = {
  aac: 'mp4a.40.2',
  libfdk_aac: 'mp4a.40.2',
  ac3: 'ac-3',
  eac3: 'ec-3',
  mp3: 'mp4a.40.34',
  libmp3lame: 'mp4a.40.34',
  opus: 'opus',
  libopus: 'opus',
  flac: 'flac',
}

const DEFAULT_VIDEO_CODEC = VIDEO_CODEC_MAP.h264
const DEFAULT_AUDIO_CODEC = AUDIO_CODEC_MAP.aac

// Falls back to H.264/AAC when a codec is missing, still 'copy' (a root
// instance with nothing to inherit from), or an encoder name this map
// doesn't know about, since the real codec can't be determined any further.
export function getMseCodecString(videoCodec?: string | null, audioCodec?: string | null): string {
  const video = (videoCodec && VIDEO_CODEC_MAP[videoCodec]) || DEFAULT_VIDEO_CODEC
  const audio = (audioCodec && AUDIO_CODEC_MAP[audioCodec]) || DEFAULT_AUDIO_CODEC

  console.log(`video: ${video}, audio: ${audio}`)

  return `video/mp4; codecs="${video}, ${audio}"`
}
